import { useFormikContext } from 'formik';
import { identity, omit } from 'ramda';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { load } from 'reducers/fspImport';
import { SCROLL_REF_KEY } from 'util/format';
import useIsImport from './useIsImport';

const useFSPImport = ({ format = identity, key, section }) => {
  const { values } = useFormikContext();
  const dispatch = useDispatch();
  const isImport = useIsImport();

  useEffect(() => {
    if (isImport) {
      const formattedValues = format(omit([SCROLL_REF_KEY], values));

      dispatch(load({ key, section, values: formattedValues }));
    }
  }, [dispatch, format, isImport, key, section, values]);
};

export default useFSPImport;
